module.exports = __webpack_public_path__ + "img/Livecopy.31d7e796.svg";